import POSCreditOptions from './POSCreditOptions';

export default POSCreditOptions;
